import {Action} from "@ngrx/store";

export const TOGGLE_USER_SUMMARIES: string = '[userSummaries] Toggle User Summaries';

export class ToggleUserSummaries implements Action {
  readonly type: string = TOGGLE_USER_SUMMARIES;
  constructor(public payload?: boolean) {}
}

export type UserSummariesAction = ToggleUserSummaries;
